import React from "react";
import { Carousel, Button, Row, Col, Typography } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";

import slide1 from "../../assets/images/slide1.JPG";
import slide2 from "../../assets/images/slide2.JPG";
import slide3 from "../../assets/images/slide3.JPG";

const { Title, Paragraph } = Typography;

export default function Acceuil() {
    const slides = [
        {
            image: slide1,
            title: "Transport rapide & sécurisé",
            desc: "Des solutions fiables pour livrer vos marchandises partout à Madagascar.",
        },
        {
            image: slide2,
            title: "Logistique intelligente",
            desc: "Optimisez votre chaîne logistique avec notre plateforme moderne.",
        },
        {
            image: slide3,
            title: "Suivi en temps réel",
            desc: "Gardez un œil sur vos opérations grâce à un tracking performant.",
        },
    ];

    return (
        <div style={{ width: "100%", minHeight: "100vh", overflowY: "auto" }}>
            {/* HERO SLIDER */}
            <Carousel
                autoplay
                effect="fade"
                autoplaySpeed={800}  // change toutes les 5 secondes
                speed={1500}
            >
                {slides.map((slide, index) => (
                    <div key={index}>
                        <div
                            style={{
                                height: "55vh",
                                backgroundImage: `url(${slide.image})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                position: "relative",
                            }}
                        >
                            {/* Overlay sombre */}
                            <div
                                style={{
                                    position: "absolute",
                                    inset: 0,
                                    background: "rgba(0,0,0,0.55)",
                                }}
                            />

                            {/* Contenu */}
                            <Row
                                align="middle"
                                justify="center"
                                style={{
                                    height: "100%",
                                    position: "relative",
                                    padding: "0 60px",
                                }}
                            >
                                <Col xs={24} md={16} style={{ textAlign: "center" }}>
                                    <Title style={{ color: "#fff", fontSize: "52px" }}>
                                        {slide.title}
                                    </Title>

                                    <Paragraph style={{ color: "#ddd", fontSize: "20px" }}>
                                        {slide.desc}
                                    </Paragraph>

                                    <Button
                                        type="primary"
                                        size="large"
                                        icon={<ArrowRightOutlined />}
                                        style={{
                                            marginTop: 20,
                                            borderRadius: "12px",
                                            padding: "0 30px",
                                            height: "50px",
                                            fontSize: "16px",
                                        }}
                                        onClick={() =>
                                            window.open("https://compagniemasoandro.mg/", "_blank")
                                        }
                                    >
                                        Découvrir nos services
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                ))}
            </Carousel>

            {/* SECTION SERVICES */}
            <div style={{ padding: "80px 60px", background: "#f9fafb" }}>
                <Row gutter={[32, 32]} justify="center">
                    <Col xs={24} md={7}>
                        <div className="serviceCard">
                            <Title level={3}>🚚 Transport</Title>
                            <Paragraph>
                                Livraison nationale rapide avec une flotte moderne et sécurisée.
                            </Paragraph>
                        </div>
                    </Col>

                    <Col xs={24} md={7}>
                        <div className="serviceCard">
                            <Title level={3}>📦 Logistique</Title>
                            <Paragraph>
                                Gestion d’entrepôts et inventaire optimisé pour vos marchandises.
                            </Paragraph>
                        </div>
                    </Col>

                    <Col xs={24} md={7}>
                        <div className="serviceCard">
                            <Title level={3}>🌍 Transit</Title>
                            <Paragraph>
                                Solutions complètes pour vos opérations import/export.
                            </Paragraph>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
